import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/logojewel.png";
import {
  PieChartOutlined,
  CarOutlined,
  FileTextOutlined,
  UserOutlined,
  TeamOutlined,
  GlobalOutlined,
  TransactionOutlined,
  SettingOutlined,
  FileProtectOutlined,
  UsergroupAddOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const dashboard = (
    <PieChartOutlined style={{ color: page === "dashboard" ? color : "" }} />
  );

  const profile = (
    <UsergroupAddOutlined style={{ color: page === "profile" ? color : "" }} />
  );

  return (
    <>
      <div className="brand">
        <img src={logo} width={40} height={40} alt="" />
        <span>Jewel Ethiopia</span>
      </div>
      <hr />
      <Menu theme="light" mode="inline" defaultOpenKeys={["general-management"]}>
        <Menu.Item key="1">
          <NavLink to="/dashboard">
            <span className="icon">{dashboard}</span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>

        <Menu.SubMenu key="general-management" title="Vehicle Management">
          <Menu.Item key="vehicles">
            <NavLink to="/vehicles">
              <span className="icon">
                <CarOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Vehicles</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="inspections">
            <NavLink to="/inspections">
              <span className="icon">
                <FileTextOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Inspection</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="owners">
            <NavLink to="/owners">
              <span className="icon">
                <TeamOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Owners</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="agreements">
            <NavLink to="/agreements">
              <span className="icon">
                <FileProtectOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Agreements</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="customerAgreements">
            <NavLink to="/customerAgreements">
              <span className="icon">
                <SafetyCertificateOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Customer Agreements</span>
            </NavLink>
          </Menu.Item>

        
        </Menu.SubMenu>

        <Menu.SubMenu key="driver-management" title="Driver Management">
          <Menu.Item key="drivers">
            <NavLink to="/drivers">
              <span className="icon">
                <UserOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Drivers</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="map">
            <NavLink to="/map">
              <span className="icon">
                <GlobalOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Tracking</span>
            </NavLink>
          </Menu.Item>
          {/* <Menu.Item key="activeDrivers">
            <NavLink to="/activeDrivers">
              <span className="icon">
                <TeamOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Active Drivers</span>
            </NavLink>
          </Menu.Item> */}
        </Menu.SubMenu>

        <Menu.SubMenu key="customer-management" title="Customer Management">
          <Menu.Item key="passengers">
            <NavLink to="/passengers">
              <span className="icon">
                <TeamOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Customers</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="reservations">
            <NavLink to="/reservations">
              <span className="icon">
                <FileTextOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Reservations</span>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>

        <Menu.SubMenu key="financial-management" title="Financial Management">
          <Menu.Item key="transactions">
            <NavLink to="/transactions">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Transactions</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="withdrawals">
            <NavLink to="/withdrawals">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Withdrawals</span>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>


        <Menu.SubMenu key="web-management" title="Website Management">
          <Menu.Item key="testimonials">
            <NavLink to="/testimonials">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Testimonials</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="teams">
            <NavLink to="/teams">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Teams</span>
            </NavLink>
          </Menu.Item>


          <Menu.Item key="about">
            <NavLink to="/about">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">About</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="contact">
            <NavLink to="/contact">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Contact Request</span>
            </NavLink>
          </Menu.Item>


          <Menu.Item key="contactInfo">
            <NavLink to="/contactInfo">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Contact Infos</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="services">
            <NavLink to="/services">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Services</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="faq">
            <NavLink to="/faq">
              <span className="icon">
                <TransactionOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">FAQ</span>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu key="configuration" title="Configuration">
          <Menu.Item key="vehicleTypes">
            <NavLink to="/vehicleTypes">
              <span className="icon">
                <SettingOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Vehicle Types</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="initialPrices">
            <NavLink to="/initialPrices">
              <span className="icon">
                <SettingOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Initial Prices</span>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>

        <Menu.SubMenu key="user-management" title="User Management">
          <Menu.Item key="users">
            <NavLink to="/users">
              <span className="icon">
                <UserOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Users</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="roles">
            <NavLink to="/roles">
              <span className="icon">
                <UsergroupAddOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Roles</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="permissions">
            <NavLink to="/permissions">
              <span className="icon">
                <TeamOutlined style={{ color: "blue" }} />
              </span>
              <span className="label">Permissions</span>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </>
  );
}

export default Sidenav;
